export const shopInfoKey = 'shopInfo';
export const colorListkey = 'colorList'; // local
export const captchaMasheryTokenKey = 'captchaMasheryToken';
export const captchaOccTokenKey = 'captchaOccToken';
export const registrationInfoKey = 'registrationInfo';
export const cartInfoKey = 'cartInfo';
export const jwtTokenKey = 'jwtToken'; // local - for owner
export const userJwtTokenKey = 'userJwtToken'; // session - for foa user
export const registrationTypeKey = 'registrationType';
export const cartFreezedKey = 'isCartFreezed';
export const sharedUrlKey = 'sharedUrl';
export const authVerifierKey = 'authVerifier';
export const isProceedEnabledKey = 'isProceedEnabled';
export const shareBarKey = 'shareBarKey';
export const isSfFlowKey = 'isSfFlow';
export const sessionKey = 'sessionInfo';
export const isAnonymousUserKey = 'isAnonymousUser';
export const isDowngradeEventKey = 'isDowngradeEvent';
